import { useNavigate } from 'react-router-dom';
import { OrderDetailTabs, type TabId } from './OrderDetailTabs';

interface Props {
  orderId: string;
  activeTab: TabId;
}

/**
 * サイドパネルの見積/納品書/請求などの一覧から開いた帳票フォーム（単独表示）で、
 * 受注詳細と同じ管理タブ群を上部に表示する。タブ選択で当該案件の受注詳細
 * （該当タブ）へ遷移し、受注一覧から開いた詳細と同じ操作感に揃える。
 */
export function OrderDocumentTabs({ orderId, activeTab }: Props) {
  const navigate = useNavigate();
  return (
    <div className="border-b border-gray-200">
      <OrderDetailTabs
        activeTab={activeTab}
        onTabChange={(tab) => navigate('/orders/' + orderId + '?tab=' + tab)}
      />
    </div>
  );
}
